import { render, staticRenderFns } from "./coachPreviewStatistic.vue?vue&type=template&id=a3a93284&scoped=true"
import script from "./coachPreviewStatistic.vue?vue&type=script&lang=ts"
export * from "./coachPreviewStatistic.vue?vue&type=script&lang=ts"
import style0 from "./coachPreviewStatistic.vue?vue&type=style&index=0&id=a3a93284&prod&scoped=true&lang=stylus"
import style1 from "./coachPreviewStatistic.vue?vue&type=style&index=1&id=a3a93284&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a93284",
  null
  
)

export default component.exports